"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatAmountWithThousandsSeparators = exports.isCurrencySymbolAfterAmount = exports.getZeroAmountPlaceholder = exports.getDecimalSeparator = exports.getOrdinalSuffix = void 0;
const locales_1 = require("../enums/locales");
const getOrdinalSuffix = (i, locale, data) => {
    if (locale === locales_1.Locales.FR) {
        if (i === 1) {
            return i + (data?.frenchGender === "M" ? "er" : "ère");
        }
        if (i === 2) {
            return i + "nd";
        }
        return i + "ème";
    }
    if (locale === locales_1.Locales.ES) {
        return i + "°";
    }
    if (locale === locales_1.Locales.DE) {
        return i + ".";
    }
    const lastDigit = i % 10;
    const lastTwoDigits = i % 100;
    if (lastDigit === 1 && lastTwoDigits !== 11) {
        return i + "st";
    }
    if (lastDigit === 2 && lastTwoDigits !== 12) {
        return i + "nd";
    }
    if (lastDigit === 3 && lastTwoDigits !== 13) {
        return i + "rd";
    }
    return i + "th";
};
exports.getOrdinalSuffix = getOrdinalSuffix;
const getDecimalSeparator = (locale) => {
    return locale === locales_1.Locales.EN ? "." : ",";
};
exports.getDecimalSeparator = getDecimalSeparator;
const getZeroAmountPlaceholder = (locale) => {
    return `0${(0, exports.getDecimalSeparator)(locale)}00`;
};
exports.getZeroAmountPlaceholder = getZeroAmountPlaceholder;
const isCurrencySymbolAfterAmount = (locale) => locale === locales_1.Locales.FR || locale === locales_1.Locales.DE;
exports.isCurrencySymbolAfterAmount = isCurrencySymbolAfterAmount;
const formatAmountWithThousandsSeparators = (value, locale) => {
    if (locale === locales_1.Locales.DE) {
        return value.toLocaleString("de-DE", { maximumFractionDigits: 2 });
    }
    return value.toLocaleString((0, exports.getDecimalSeparator)(locale) === "," ? "fr-CA" : "en-CA", { maximumFractionDigits: 2 });
};
exports.formatAmountWithThousandsSeparators = formatAmountWithThousandsSeparators;
